class DateTimeFormatter {
  constructor(lang) {
    this.lang = lang;
    this.cached = {};
  }

  format(date, options) {
    return this.getFormatter(options).format(date);
  }

  formatToParts(date, options) {
    return this.getFormatter(options).formatToParts(date);
  }

  formatRange(date1, date2, options) {
    return this.getFormatter(options).formatRange(date1, date2);
  }

  formatRangeToParts(date1, date2, options) {
    return this.getFormatter(options).formatRangeToParts(date1, date2);
  }

  formatRangeSplit(date1, date2, options) {
    const parts = this.formatRangeToParts(date1, date2, options);

    const splits = {
      startRange: '',
      endRange: '',
      sharedBefore: '',
      sharedBetween: '',
      sharedAfter: '',
    };

    for (const part of parts) {
      switch (part.source) {
        case 'startRange':
          splits.startRange += part.value;
          break;
        case 'endRange':
          splits.endRange += part.value;
          break;
        case 'shared':
          if (!splits.startRange) {
            splits.sharedBefore += part.value;
          } else if (!splits.endRange) {
            splits.sharedBetween += part.value;
          } else {
            splits.sharedAfter += part.value;
          }
          break;
      }
    }

    return splits;
  }

  weekdays(format) {
    const weekdays = [];
    for (let day = 4; day <= 10; day++) {
      weekdays.push(this.format(new Date(1970, 0, day), {weekday: format}));
    }
    return weekdays;
  }

  splitParts(parts, splitAt) {
    const splits = [];
    if (parts.length === 0) {
      return '';
    }
    let currentSplit = parts[0].value;
    for (let i = 1; i < parts.length; i++) {
      const part = parts[i];
      if (splitAt.indexOf(part.type) !== -1) {
        splits.push(currentSplit);
        currentSplit = '';
      }

      currentSplit += part.value;
    }

    if (currentSplit) {
      splits.push(currentSplit);
    }

    return splits;
  }

  /**
   * @param options
   * @return Intl.DateTimeFormat
   */
  getFormatter(options) {
    const lang = localStorage.getItem('dashboard-lang') || this.lang;
    const key = JSON.stringify([lang, options]);
    if (!this.cached[key]) {
      this.cached[key] = new Intl.DateTimeFormat(lang, options);
    }
    return this.cached[key];
  }
}

export {DateTimeFormatter};
